import frameAgenda from "../assets/images/onda-conteudo-agenda-resize.jpg";
import frameConselho from "../assets/images/onda-conteudo-conselho-resize.jpg";
import frameDecisoes from "../assets/images/onda-conteudo-decisoes-resize.jpg";
import frameIBDA from "../assets/images/onda-conteudo-ibda-resize.jpg";
import frameNormas from "../assets/images/onda-conteudo-normas-resize.jpg";
import frameTeses from "../assets/images/onda-conteudo-teses-resize.jpg";
import frameSociais from "../assets/images/onda-conteudo-social-resize.jpg";
import frameOnlineCodaip from "../assets/images/onda-conteudo-online-CODAIP-resize.png";

const mock = [
  {
    src: frameIBDA,
    url: "/destaques/9",
    isExternalLink: false,
    description: "IBDAutoral",
    condition: true,
  }, 
{
  src: frameTeses,
  url: "/destaques/11",
  isExternalLink: false,
  description: "Banco de Teses",
  condition: true,
}, 
{
  src: frameNormas,
  url: "/destaques/12",
  isExternalLink: false,
  description: "Normas Jurídicas",
  condition: true,
}, 
{
  src: frameSociais,
  url: "/destaques/13",
  isExternalLink: false,
  description: "Redes Sociais",
  condition: true,
},
{
  src: frameDecisoes,
  url: "/destaques/10",
  isExternalLink: false,
  description: "Decisões Judiciais",
  condition: true,
},
{
  src: frameOnlineCodaip,
  //url: "https://www.gedai.com.br/xvi-codaip-chamadas-de-artigos",
  url: "/destaques/14",
  isExternalLink: false,
  description: "",
  condition: new Date() > new Date("2022-10-03") && new Date("2022-10-06") > new Date(),
},
{
  src: frameConselho,
  url: "/sobre",
  isExternalLink: false,
  description: "Conselho Científico",
  condition: true,
},
{
  src: frameAgenda,
  url: "/agenda",
  isExternalLink: false,
  description: "Agenda",
  condition: true,
},
];

export default mock;